import {
  LayoutDashboard,
  Inbox,
  Building,
  Building2,
  Truck,
  Wallet,
  FileText,
  Receipt,
  BarChart3,
  FileBarChart,
  User,
  KeyRound,
} from "lucide-react";

/**
 * Modelo de navegação do shell (formato NavSection[] da lib @lukos-tecnologia/ui).
 *
 * Fonte única do menu lateral — derivado de routes.js. Motorista (em Cadastros)
 * e Trocar senha (link ao final) estão incluídos aqui; no routes.js seguem com
 * `visible: false`, o que só afeta a sidebar Material legada (não a Lukos).
 *
 */
const navSections = [
  {
    // Link direto (grupo sem subitens → usa `href`, como no shell do erpFront).
    key: "visaogeral",
    label: "Visão Geral",
    order: 1,
    GroupIcon: LayoutDashboard,
    href: "/admin/VisaoGeral",
    items: [],
  },
  {
    key: "aberto",
    label: "Em Aberto",
    order: 2,
    GroupIcon: Inbox,
    href: "/admin/dashboard",
    items: [],
  },
  {
    key: "cadastros",
    label: "Cadastros",
    order: 3,
    GroupIcon: Building2,
    items: [
      { key: "empresa", to: "/admin/Empresa", label: "Empresa", Icon: Building },
      { key: "frota", to: "/admin/Frota", label: "Frota", Icon: Truck },
      { key: "motorista", to: "/admin/Motorista", label: "Motorista", Icon: User },
    ],
  },
  {
    key: "financeiro",
    label: "Financeiro",
    order: 4,
    GroupIcon: Wallet,
    items: [
      { key: "faturas", to: "/admin/Faturas", label: "Faturas", Icon: FileText },
      {
        key: "requisicao",
        to: "/admin/RequisicaoAbastecimento",
        label: "Requisição Abastecimento",
        Icon: Receipt,
      },
      {
        key: "contacorrente",
        to: "/admin/ContaCorrente",
        label: "Conta Corrente",
        Icon: Wallet,
      },
    ],
  },
  {
    key: "relatorios",
    label: "Relatórios",
    order: 5,
    GroupIcon: BarChart3,
    items: [
      {
        key: "extratoconsumo",
        to: "/admin/extratoconsumo",
        label: "Extrato de Consumo",
        Icon: FileBarChart,
      },
    ],
  },
  {
    // Link direto (conta/segurança) ao final do menu.
    key: "trocarsenha",
    label: "Trocar senha",
    order: 6,
    GroupIcon: KeyRound,
    href: "/admin/recuperaSenha",
    items: [],
  },
];

// reexport para conveniência de ícones de relatório futuros
export { BarChart3 };
export default navSections;
